import { Component, Input } from '@angular/core';
import { ChecklistItem } from 'app/interfaces/checklistItem';

@Component({
	selector: 'bb-checklist-item',
	templateUrl: './bb-checklist-item.component.html',
	styleUrls: ['./bb-checklist-item.component.scss']

})
export class BbChecklistItemComponent {
	@Input() item: ChecklistItem;
}
